import { render, staticRenderFns } from "./WalletBalanceChip.vue?vue&type=template&id=0ec878ff&scoped=true&"
import script from "./WalletBalanceChip.vue?vue&type=script&lang=js&"
export * from "./WalletBalanceChip.vue?vue&type=script&lang=js&"
import style0 from "./WalletBalanceChip.vue?vue&type=style&index=0&id=0ec878ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec878ff",
  null
  
)

export default component.exports